import React from "react";
import styles from "../appointmentFlow.module.css";

interface InlineErrorProps {
  message?: string | null;
}

/**
 * Minimal inline error banner for the appointment modal.
 * Renders a styled alert-like block; renders nothing when message is empty.
 */
const InlineError: React.FC<InlineErrorProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div role="alert" className={styles.inlineError}>
      {message}
    </div>
  );
};

export default InlineError;
